import React, {Component} from 'react';

import WizardNavigator from './WizardNavigator'

class NavigatorFoto extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }
  setStateGlobal = (state) => {
    const {setParentState} = this.props;
    setParentState(state);
  }
  setStateGlobalSteps = (state) => {
    const {setParentStateSteps} = this.props;
    setParentStateSteps(state);
  }
  render() {

    const {
      leftFirstDivClassName,
      leftSecondDivClassName,
      leftTextSecondDivClassName,
      leftLabelClassNameTittle,
      leftLabelTextTittle,
      leftLabelClassNameDescription,
      leftLabelDescription,
      rightFirstDivClassName,
      rightSecondDivClassName,
      rightTextSecondDivClassName,
      rightLabelClassNameTittle,
      rightLabelTextTittle,
      rightLabelClassNameDescription,
      rightLabelDescription,
      leftBarClassName,
      parentState
    } = this.props;

    return (<nav className='nav'>
      <div className='nav-center'>
        <WizardNavigator firstDivClassName={leftFirstDivClassName} secondDivClassName={leftSecondDivClassName} textSecondDivClassName={leftTextSecondDivClassName} labelClassNameTittle={leftLabelClassNameTittle} textLabelTittle={leftLabelTextTittle} labelClassNameDescription={leftLabelClassNameDescription} textLabelDescription={leftLabelDescription} parentState={parentState} setParentStateSteps={this.setStateGlobalSteps} pageToRender={8}/>
        <div className="wizard-separator w-s1-fix">
          <div className={leftBarClassName}></div>
        </div>
        <WizardNavigator firstDivClassName={rightFirstDivClassName} secondDivClassName={rightSecondDivClassName} textSecondDivClassName={rightTextSecondDivClassName} labelClassNameTittle={rightLabelClassNameTittle} textLabelTittle={rightLabelTextTittle} labelClassNameDescription={rightLabelClassNameDescription} textLabelDescription={rightLabelDescription} parentState={parentState} setParentStateSteps={this.setStateGlobalSteps} pageToRender={9}/>
      </div>
    </nav>);
  }
}

export default NavigatorFoto;
